const topics = [
  { label: '繁花沪语版', heat: '987万', tag: '热播' },
  { label: '流浪地球3', heat: '856万', tag: '新片' },
  { label: '庆余年2大结局', heat: '743万', tag: '热议' },
  { label: '暑期档推荐', heat: '692万', tag: '专题' },
  { label: '悬疑剧片单', heat: '581万', tag: '分类' },
  { label: '4K高清专区', heat: '524万', tag: '画质' },
  { label: '乘风破浪', heat: '498万', tag: '综艺' },
  { label: '国产动漫崛起', heat: '437万', tag: '动漫' },
  { label: '经典港片重温', heat: '389万', tag: '怀旧' },
  { label: '韩剧热播榜', heat: '356万', tag: '海外' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">热门话题</h2>
          <p className="text-sm text-foreground-500">大家都在讨论的影视热点</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-[1000px] mx-auto">
          {topics.map((topic) => (
            <div
              key={topic.label}
              className="group flex items-center gap-3 px-5 py-3 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors">
                #{topic.label}
              </span>
              <span className="flex-shrink-0 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                {topic.tag}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}